import { render, staticRenderFns } from "./memberVirtualThemeStf.vue?vue&type=template&id=33d2c5b6"
import script from "./memberVirtualThemeStf.vue?vue&type=script&lang=js"
export * from "./memberVirtualThemeStf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports